import { render, staticRenderFns } from "./CustomerSystem.vue?vue&type=template&id=1922fc45&"
import script from "./CustomerSystem.vue?vue&type=script&lang=js&"
export * from "./CustomerSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports